import {createSlice} from '@reduxjs/toolkit';

export const jobsSlice = createSlice({
    name: 'jobsReducer',
    initialState: {
        jobs: JSON.parse(sessionStorage.getItem('jobs')) || []
    },
    reducers: {
        setJobs: (state, action) => {
            state.jobs = action.payload;
        },
        deleteJob: (state, action) => {
            state.jobs.splice(action.payload, 1)
        },
        repairTips: (state, action) => {
            const { index, status } = action.payload;
            if (!state.jobs[index]) return;

            state.jobs[index].repair_tips = status;
        },
        pushJob: (state, action) => {
            const job = {...action.payload};
            state.jobs.push(job);
            job.detail = Object.assign({}, job.detail, {amount: 1, price: 0});
        },
        pushDetail: (state, action) => {
            const customDetail = {
                job_id: null,

                // NOTE: Вызывает баги. Сейчас как custom используется detailOnly.
                // custom: true, 

                detail: {
                    detailOnly: true,
                    amount: 1,
                    part_id: null,
                    part_name: "",
                    price: 0
                },
                operation: {
                    operation_name: '',
                    operation_id: null
                },
                hourPrice: 0,
                difficulty: 1,
                sdh_hour: 0,
            }
            state.jobs.push(customDetail)
        },
        setCustomJobsSystems: (state, action) => {
            if (state.jobs[action.payload.index]) {
                if (action.payload?.superSystem){
                    state.jobs[action.payload.index].superSystem = {...action.payload.superSystem}
                }
                if (action.payload?.system){
                    state.jobs[action.payload.index].system = {...action.payload.system}
                }
                if (action.payload?.superSystem === null && state.jobs[action.payload.index].hasOwnProperty('superSystem')){
                    delete state.jobs[action.payload.index].superSystem;
                }
                if (action.payload?.system === null &&  state.jobs[action.payload.index].hasOwnProperty('system')){
                    delete state.jobs[action.payload.index].system;
                }
            }
            //console.log({jobsInf: state.jobs[action.payload.index], action})
        },
        setJobSdhHours: (state, action) => {
            state.jobs[action.payload.index].sdh_hour = action.payload.sdh_hour
            // console.log(action.payload.sdh_hour)
        },
        setCatalogJobsDetailName: (state, action) => {
            state.jobs[action.payload.index].detail.part_name = action.payload.part_name
            state.jobs[action.payload.index].detail.part_id = action.payload.part_id
            state.jobs[action.payload.index].detail.code = action.payload.code

            if (state.jobs[action.payload.index].detail.code === 'W') {
                state.jobs[action.payload.index].operation.operation_name = ''
                state.jobs[action.payload.index].operation.operation_id = null
            }
        },
        setCustomJobsDetailName: (state, action) => {
            state.jobs[action.payload.index].detail.part_name = action.payload.part_name
            state.jobs[action.payload.index].detail.part_id = null
            state.jobs[action.payload.index].detail.code = null
        },
        setCatalogJobsOperationName: (state, action) => {
            state.jobs[action.payload.index].operation.operation_name = action.payload.operation_name
            state.jobs[action.payload.index].operation.operation_id = action.payload.operation_id
            state.jobs[action.payload.index].detail.amount = 1
            state.jobs[action.payload.index].detail.price = 0
        },
        setCustomJobsOperationName: (state, action) => {
            state.jobs[action.payload.index].operation.operation_name = action.payload.operation_name
            state.jobs[action.payload.index].operation.operation_id = null
            state.jobs[action.payload.index].detail.amount = 1
            state.jobs[action.payload.index].detail.price = 0
        },
        setJobDifficulty: (state, action) => {
            state.jobs[action.payload.index].difficulty = action.payload.difficulty
        },
        setJobAllEngines: (state, action) => {
            state.jobs[action.payload.index].allEngines = action.payload.status;
        },
        setDetailAmount: (state, action) => {
            state.jobs[action.payload.index].detail.amount = action.payload.amount
        },
        setDetailPrice: (state, action) => {
            state.jobs[action.payload.index].detail.price = action.payload.price
        },
        setDetailHidden: (state, action) => {
            const {index, hidden} = action.payload;

            state.jobs[index].detail.hidden = hidden;
        },
        setDetailCustomVatValue: (state, action) => {
            const {index, value} = action.payload;

            state.jobs[index].detail.custom_vat_value = value;
        },
    },
});

export const {
    setJobs,
    deleteJob,
    pushJob,
    pushDetail,
    setJobSdhHours,
    setCatalogJobsDetailName,
    setCustomJobsDetailName,
    setCatalogJobsOperationName,
    setCustomJobsOperationName,
    setJobDifficulty,
    setJobAllEngines,
    setDetailAmount,
    setDetailPrice,
    setDetailHidden,
    setDetailCustomVatValue,

    repairTips,
    setCustomJobsSystems
} = jobsSlice.actions;

export default jobsSlice.reducer;
